/**
 * What the thread list's order switch is called.
 *
 * Here rather than inline so that native, which offers the same switch, reads
 * the same words: the labels for one control belong in one file, or the two
 * apps word it differently and nothing fails.
 *
 * Keyed by the order the control switches *to*, so the label names the order
 * you would move to rather than the one you are in.
 */
export const sortSwitchLabels = {
  /** Threads waiting on the user, hoisted above the date-ordered remainder. */
  needsAttentionFirst: "Needs attention first",
  /** Plain date order, which is what the list does unless asked otherwise. */
  recent: "Recent first",
} as const;

/**
 * The same orders, opened with the verb so the item reads as the action it
 * performs rather than a state to decode.
 *
 * Only where the control has room: an iOS menu sizes its own popup and caps it
 * around 250pt, so on native the prefix costs a second line while the plain
 * label fits on one. Derived from the table above so the two forms cannot name
 * the order differently.
 */
export const sortSwitchActions = {
  needsAttentionFirst: `Sort ${sortSwitchLabels.needsAttentionFirst}`,
  recent: `Sort ${sortSwitchLabels.recent}`,
} as const;
